module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    Relative speed of blocks found compared to the target of 6 blocks per hour (although the 6 blocks per hour is only a proxy for the actual target of 2016 blocks every two weeks).\n  ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('stat-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-speed"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c694d03c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/speed.vue
// module id = 562
// module chunks = 1